export const appLanguages = {
  english: 'en',
  spanish: 'es',
} as const;

export type AppLanguage = (typeof appLanguages)[keyof typeof appLanguages];

export const supportedAppLanguagesNames: Record<AppLanguage, { name: string }> = {
  [appLanguages.english]: { name: 'English' },
  [appLanguages.spanish]: { name: 'Spanish' },
};
